import { ListViewBlock } from "./ListViewBlock";

export const EventsListView = () => (
  <div className="space-y-12">
    <ListViewBlock count={5} />
    <ListViewBlock count={3} />
  </div>
);
